import React from 'react'
import { Link } from 'react-router-dom'
import { Image } from '@deal/components'
import { SellableCardFragment } from '#src/generated/graphql'
import truncate from 'lodash/truncate'
import { formatSellablePricing, getSellableUrl } from '#src/services/sellable'
import styles from './styles.css'

interface SellableListProps {
  sellables: SellableCardFragment[]
}

const SellableList: React.SFC<SellableListProps> = ({ sellables }) => {
  return (
    <div className={styles.sellables}>
      {sellables.slice(0, 4).map(sellable => {
        if (sellable.images.length === 0) {
          return null
        }

        const sellableImage = sellable.images[0]
        const sellablePrice = formatSellablePricing(
          sellable,
          {
            percentSavingsDisplayThreshold: 5
          },
          {
            preferDefaultVariant: true
          }
        )

        return (
          <div className={styles.sellable} key={sellable.id}>
            <Link to={getSellableUrl(sellable)}>
              <div className={styles.image}>
                {sellable.brand &&
                  sellable.brand.logo && (
                    <div className={styles.brand}>
                      <Image
                        src={sellable.brand.logo.url}
                        width={40}
                        height={40}
                        imgixParams={{
                          fit: 'crop'
                        }}
                      />
                    </div>
                  )}
                <Image src={sellableImage.url} width={200} className={styles.sellableImage} />
              </div>
            </Link>
            <div className={styles.title}>
              <Link to={getSellableUrl(sellable)} className={styles.titleLink}>
                {truncate(sellable.title, {
                  length: 45
                })}
              </Link>
            </div>
            {sellablePrice && (
              <div className={styles.pricingRow}>
                <div className={styles.price}>{sellablePrice.price}</div>
                {sellablePrice.msrp && <div className={styles.msrp}>{sellablePrice.msrp}</div>}
              </div>
            )}
          </div>
        )
      })}
    </div>
  )
}

export default SellableList
